export const DomesticAirlines = ["QH", "VJ", "VU", "VN", "9G"];
export const InternationalAirlines = ["1A", "1B"];
